import React, { useEffect, useState } from 'react'
import BreadCrumbBar from '../../common/breadCrumbBar/BreadCrumbBar'
import '../../css/common.css'
import { DataGrid } from '@mui/x-data-grid';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,  Button, CircularProgress, IconButton, stepContentClasses } from '@mui/material';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import RemoveCircleRoundedIcon from '@mui/icons-material/RemoveCircleRounded';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import SearchBar from '../../common/searchBar/SearchBar';
import ExportExcel from '../../common/excel/ExportExcel';
import moment from 'moment';
import { ApiService } from '../../services/apiService';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Warning from '../../common/alert/Warning';
import { dateFormat } from '../../common';


export default function FirmwareList() {
	const navigate = useNavigate();
  const [rowData, setRowData] = useState([]);
	const [containData, setContainData] = useState({});
	const [page, setPage] = useState(0);
	const [rowCount, setRowCount] = useState(0);
	const [totalLength, setTotalLength] = useState(0);
	const [excelClick, setExcelClick] = useState(false);
	const [excelList, setExcelList] = useState([]);
	const [alertOpen, setAlertOpen] = useState(false);
	const [clickItem, setClickItem] = useState('');
	const [loading, setLoading] = useState(false);
	let params = "";
	const authData = useSelector(state => state.auth);
	const role = authData.user.role.includes("firmwares");
	const [openWarning, setOpenWarning] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	const [paginationModel, setPaginationModel] = useState({
		page: 0,
		pageSize: 30,
	});

	const closeWarning = (data) => {
		setOpenWarning(data);
	}

	const xlsxHeader = {
		header: [
			'파일명', 'F/W버전', '파일크기', '등록일자'
		]
	}

	const today = moment().format('YYYY-MM-DD');
	const xlsxFileName = "펌웨어파일리스트_" + today;

	const getExcelData = async () => {
    setExcelClick(false);
    setLoading(true);
    params = `limit=${totalLength}`;

		try {
			const response = await ApiService.getFirmwareList(params);
			const excelRows = response.data.datas.map((data) => {
        data.created = dateFormat(new Date(data.created));
        return {
          파일명: data.filename,
          "F/W버전": data.fwver,
          파일크기: data.fwsize,
          등록일자: data.created,
        };
      });
			setExcelClick(true);
      setExcelList(excelRows);
		} catch(error) {
			console.log("FirmwareList - getExcelData - error :: ", error);
		} finally {
			setLoading(false);
		}
  };

	const alertOpenHandle = (id) => {
		setAlertOpen(true);
		setClickItem(id);
	}

	const alertCloseHandle = () => {
		setAlertOpen(false);
		setClickItem('');
	}

	const handleDelete = async () => {
		try {
			await ApiService.firmwareDelete(clickItem);
			alertCloseHandle();
		} catch (error) {
			console.log('FirmwareList - handleDelete - error :: ', error)
		} finally {
			getFirmware(paginationModel.pageSize, paginationModel.page);
		}
	}

	const uploadClick = () => {
		return navigate('/firmware/upload');
	}

	const columns = [
		{
			field: 'filename',
			headerName: '파일명',
			minWidth: 360,
			flex: 1,
			// renderCell: (params) => {
			// 	return (
			// 		<p onClick={() => {navigate(`/firmware/${params.row.id}`, {state: {
			// 			id : params.row.id,
			// 			filename : params.row.filename,
			// 			fwver : params.row.fwver,
			// 			fwsize : params.row.fwsize,
			// 			created : params.row.created, 
			// 		}})}} style={{cursor:"pointer"}}>{params.value}</p>
			// 	)
			// }
		},
		{
			field: 'fwver',
			headerName: 'F/W버전',
			minWidth: 260,
			flex: 2,
		},
		{
			field: 'fwsize',
			headerName: '파일크기',
			minWidth: 160,
			flex: 1,
		},
		{
			field: 'created',
			headerName: '등록일자',
			minWidth: 160,
			flex: 1,
		},
		{
			field: 'download',
			headerName: '다운로드',
			minWidth: 100,
			flex: 1,
			renderCell: (params) => {
				return (
					<>
						<button className="editBtn" onClick={() => {fwDownload(params.row.fwver, params.row.filename)}}><DownloadRoundedIcon sx={{pr:1, verticalAlign: "-1px", fontSize: "15px"}}/>저장</button>
					</>
				)
			}
		},
		{
			field: 'delete',
			headerName: '삭제',
			minWidth: 100,
			flex: 1,
			renderCell: (params) => {
				// you will find row info in params
				return(
					<>
						<button className="deleteBtn" onClick={() => alertOpenHandle(params.row.id)}><RemoveCircleRoundedIcon sx={{pr:1, verticalAlign: "-1px", fontSize: "15px"}}/>삭제</button>
					</>
				)
			}
		},
	];

	const options = [
		{ 
			value: 'none',
			item: '검색할 항목 선택',
		},
		{ 
			value: 'filename',
			item: '파일명',
		},
		{ 
			value: 'fwver',
			item: 'F/W 버전',
		},
	];

	const getFirmware = async (limit, page) => {
		params = `limit=${limit}&offset=${limit*page}&contains=${JSON.stringify(containData)}`;
		
		try {
			setLoading(true);
			const firmwareList = await ApiService.getFirmwareList(params);
			//엑셀 출력 시 정체 리스트를 조회해야하기 때문에
			if(JSON.stringify(containData) === '{}') {
				setTotalLength(firmwareList.data.total);
			}

			const rows = firmwareList.data.datas.map((data) => {
				// data.created = data.created.substr(0, 10);
				data.created = dateFormat(new Date(data.created))
				return data;
			})

			setRowData(rows);
			setRowCount(firmwareList.data.total);
		} catch(error) {
			console.log('FirmwareList - getFirmware - error :: ', error)
		} finally {
			setLoading(false);
		}
	}

	const fwDownload = (fileVer, fileName) => {
		const fileValue = fileVer + "_"  + fileName;

		ApiService.firmwareDownload(fileValue).then((response) => {
			// console.log('response', response);
			const blob = new Blob([response.data]) 

			const fileUrl = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = fileUrl;
			link.download = fileName;
			link.style.display = 'none';

			document.body.appendChild(link);
			link.click();
			link.remove();
		}).catch((error) => {
			setOpenWarning(true);
			setErrorMsg('다운로드 실패!');
			console.log(error.message);
		})
	}

	useEffect(() => {
		getFirmware(paginationModel.pageSize, paginationModel.page, containData);
	}, [paginationModel.page, containData])

	const getData = (selectValue, inputValue) => {
		if ((selectValue === "none") && (inputValue !== "")) {
			setOpenWarning(true);
			setErrorMsg('검색할 항목을 선택하세요!');
		} else {
			if(inputValue === "") {
				setContainData({})
			} else {
				setContainData({ [selectValue]: inputValue.trim() });
			}
			setPage(0);
		}
	}

	return (
    <div className="containList">
      {role !== true ? (
        <Warning
          open={openWarning}
          onHideWarning={closeWarning}
          warningMsg={"해당 메뉴에 대한 권한이 없습니다!"}
        ></Warning>
      ) : (
        <>
          <BreadCrumbBar menu="펌웨어 관리" />
          <div className="firmwareMenu">
            <div className="firmwareContainItem">
              <div className="excelBtn" onClick={getExcelData}>
                <ExportExcel
                  excelClick={excelClick}
                  header={xlsxHeader}
                  excelData={excelList}
                  fileName={xlsxFileName}
                />
                <Button
                  sx={{ pr: "20px", pl: "20px", ml: "10px" }}
                  variant="contained"
                  startIcon={<FileUploadIcon />}
                  onClick={uploadClick}
                >
                  업로드
                </Button>
              </div>
              <SearchBar options={options} getData={getData} />
            </div>
          </div>
          <div className="gridItem">
            {loading && (
              <CircularProgress
                sx={{ position: "absolute", top: "50%", left: "50%" }}
              />
            )}
            <DataGrid
              sx={{
                ".MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bold",
                },
              }}
              paginationMode="server"
              rows={rowData}
              columns={columns}
              columnHeaderHeight={35}
              rowHeight={23}
              autoHeight={true}
              disableSelectionOnClick
              pageSizeOptions={[paginationModel.pageSize]}
              rowCount={rowCount}
              onPaginationModelChange={setPaginationModel}
              paginationModel={paginationModel}
              disableColumnMenu={true}
            />
          </div>

          <Warning
            open={openWarning}
            onHideWarning={closeWarning}
            warningMsg={errorMsg}
          ></Warning>

          <Dialog
            open={alertOpen}
            onClose={alertCloseHandle}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle
              id="responsive-dialog-title"
              sx={{ width: "350px", fontWeight: 600 }}
            >
              <ErrorOutlineRoundedIcon sx={{ pr: 1, verticalAlign: "-4px" }} />
              삭제 경고
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                sx={{ fontWeight: 600, m: "15px 0px 0px 10px" }}
              >
                삭제한 데이터는 다시 되돌릴 수 없습니다. <br />
                정말 삭제하시겠습니까?
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ p: "8px 20px 10px 8px" }}>
              <Button onClick={alertCloseHandle}>취소</Button>
              <Button onClick={handleDelete}>확인</Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </div>
  );
}
